import { createSearchParams, generatePath, type To } from 'react-router-dom';

import { PAGE_URLS } from 'src/components/Router';
import type { Card, Mode, Page } from 'src/types';

export type Params = Record<string, unknown> & {
  id?: string;
};

export interface RouteParams {
  page?: Page;
  name?: string;
  to?: Card;
  card?: Card;
  id?: string;
  mode?: Mode;
  params?: Record<string, any>;
  lang?: string;
}

export const generateNavigateTo = (routeParams: RouteParams): To => {
  const { page, name, to, card, id, mode, lang, params = {} } = routeParams;

  return {
    pathname: page
      ? generatePath(PAGE_URLS[page], { card: card || to, id, name, lang })
      : undefined,
    search: createSearchParams({
      ...params,
      ...(typeof mode !== 'undefined'
        ? { mode: mode.toLocaleLowerCase() }
        : {}),
    }).toString(),
  };
};
